import Swiper from 'swiper/bundle';
import { A11y } from 'swiper/modules';

window.Swiper = Swiper;

window.RecentBlogsSlider = () => {
	return {
    swiper: null,
    init() {
      setTimeout(() => {
        this.swiper = new Swiper(this.$refs.swiperContainer, {
          modules: [A11y],
          a11y: {
            enabled: true,
          },
          watchSlidesProgress: true,
          loop: true,
          grabCursor: true,
          spaceBetween: 10,
          slidesPerView: 1,
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
          pagination: {
            el:this.$refs.swiperPagination,
            clickable: true,
            // type: 'bullets',
            renderBullet: function (index, className) {
                return '<div class="' + className + '"><div class="dot"></div></div>'
            }
          },
          navigation: {
            nextEl: this.$refs.swiperNext,
            prevEl: this.$refs.swiperPrev,
          },
        });
      }, 0);
    },
	};
};
